import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
import HtmlParser from "react-html-parser";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Initial Consultation",
    description: "Understand goals and challenges to set clear ASO objectives.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Strategy Development",
    description:
      "Develop a tailored ASO strategy aligned with your app's target market.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Ongoing Optimization",
    description:
      "Continuously monitor and adjust strategies to enhance app visibility.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Performance Reviews",
    description:
      "Provide transparent reporting and actionable insights for continuous improvement.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Dedicated Support",
    description:
      "Offer consistent support and expert guidance throughout your app’s growth.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Scaling & Expansion",
    description: "Help scale your app to reach new markets and user segments.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow digital_marketing_flow speech_business_solutions p-100 "
      style={{ background: "#f9f9f9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Easy-to-Navigate, Helpful <span>Engagement Model</span>
            </h2>
            {/* <p>
              Whether your goal is to upscale your current content management
              system or integrate a new one, our expert CMS developers help you
              plan and build customizable products with enterprise-grade
              features. Strengthen your Content Delivery Network with high
              customizability, headless architecture, and workflow automation.
            </p> */}
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
              <div className="workflow_items" style={{ background: "#fff" }}>
                <div className="item_name">
                  <span>{item.count}</span>
                  {HtmlParser(item.title)}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        {/* <Row>
          <Col
            xs={12}
            md={12}s
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3 mt-md-5"
          >
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your CMS Project
            </Link>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default Workflow;
